// @flow

import React, { useState, useRef, useEffect } from "react";
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import caretDown from '@fortawesome/fontawesome-free-solid/faCaretDown';
import timesCircle from '@fortawesome/fontawesome-free-solid/faTimesCircle';
import search from '@fortawesome/fontawesome-free-solid/faSearch';

const Menu = ({ categories, activeCategory, setCategory, query, setQuery }): React$Element<div> => {
  const [showSearch, setShowSearch] = useState(false);
  const [showCategories, setShowCategories] = useState(false)
  const searchInput = useRef(null);

  const enableSearch = (e) => {
    e.preventDefault();
    setShowSearch(true);
  };

  const disableSearch = (e) => {
    e.preventDefault();
    setShowSearch(false)
    setQuery("");
  };

  const toggleHideCategories = () => {
    setShowCategories(!showCategories)
  }

  useEffect(() => {
    if (showSearch) {
      searchInput.current.focus();
    }
  }, [showSearch]);

  return (
    <div className="u-centered">
      <div className={`${!showSearch ? "hidden" : ""}`}>
        <div className="search-field search-field--compact">
          <div className="position-absolute left margin-top-2 margin-left-2">
            <FontAwesomeIcon icon={search} />
          </div>
          <div className="position-absolute right h-100 w-12 align-right" onClick={disableSearch}>
            <FontAwesomeIcon icon={timesCircle} className="margin-top-3 margin-right-2"/>
          </div>
          <input ref={searchInput} name="search_field" placeholder="Zoeken" value={query} onChange={(e) => setQuery(e.target.value)} className="search-field__input" />
        </div>
      </div>
      <div className={`${showSearch ? "hidden" : "flex med-inline"}`}>
        <div className="category-items-wrapper flex-1 med-inline">
          {categories.map((category) => {
            const CustomTag = `${activeCategory === category.slug ? "h1" : "a"}`;
            return (<CustomTag key={category.slug} href={`${category.url}`}
              onClick={(e) => {
                e.preventDefault();
                setCategory(category.slug);
                toggleHideCategories();
              }}
              className={
                `js-gids-tab category-item block med-inline position-relative
                ${!showCategories && activeCategory !== category.slug ? "hidden" : ""}
                ${activeCategory === category.slug ? "is-active" : ""}`
              }>
              {category.tab}
              <span className={
                `hidden-m margin-right-1 right position-absolute transition
                ${activeCategory !== category.slug ? "hidden" : ""}
                ${showCategories && "rotate-180"}`
              }>
                <FontAwesomeIcon icon={caretDown} />
              </span>
            </CustomTag>)
            }
          )}
        </div>
        <a id="film-search" className="js-gids-tab category-item block med-inline flex-initial margin-0 bg-none" href="#" onClick={enableSearch}>
          <FontAwesomeIcon icon={search} />
        </a>
      </div>
    </div>
  )
}

export default Menu;
